import Pokeball from "../../components-v2/landing/pokemon-trainer/Pokeball";
import Sparkles from "../../components-v2/landing/pokemon-trainer/Sparkles";
import HTMLHead from "../../components/blocks/HTMLHead";
import MetaElement from "../../components/elements/MetaElement";

// ─────────────────────────────────────────────────────────────────────────
// EDIT BELOW: all user-facing copy and links live here.
// Section-level chrome (titles, kickers, subheads, badges, CTAs, footer) is
// in CONTENT; the content tables (BENEFITS / STEPS / RULES) follow.
// ─────────────────────────────────────────────────────────────────────────

const CONTENT = {
  meta: {
    brandName:          "KRIT.RO",
    contactEmail:       "contact@krit.ro",
    homeUrl:            "https://krit.ro",
    eventsUrl:          "https://krit.ro/calendar",
    discordConnectUrl:  "https://krit.ro/cont/contul-meu"
  },
  hero: {
    badge:        "Rol Nou Exclusiv",
    titleTop:     "POKÉMON",
    titleBottom:  "TRAINER",
    subtitle:     "Devino parte din comunitatea Pokémon KRIT. Implicarea si activitatea in comunitate iti pot oferi acces la beneficii speciale, acces prioritar si perks dedicate membrilor activi.",
    ctaPrimary:   "Cum îl obțin?",
    ctaSecondary: "Conectează-te la Discord"
  },
  benefits: {
    kicker:   "Beneficii",
    title:    "Ce primești?",
    subtitle: "Beneficii disponibile automat membrilor Pokémon Trainer."
  },
  steps: {
    kicker:   "Cale de acces",
    title:    "Cum îl obții?",
    subtitle: "Rolul se câștigă prin implicare reală în comunitatea Pokémon KRIT — la evenimente sau pe Discord.",
    notice: {
      badge: "Important — ai timp până pe 31 august",
      text:  <>Ai primit rolul <strong>fără</strong> un cont Pokémon Trainer Club? Înscrie-te cu el la orice eveniment KRIT între <strong>1 iulie și 31 august 2026</strong> ca să-l păstrezi.</>,
      cta:   "Vezi evenimentele"
    }
  },
  rules: {
    title:    "Cum păstrezi rolul",
    subtitle: "Rolul se câștigă prin implicare și se păstrează la fel. Câteva reguli simple de reținut:"
  },
  cta: {
    badge:    "Ai deja rolul?",
    title:    "Conectează-ți contul Discord",
    subtitle: "Leagă contul Discord de profilul KRIT.RO și beneficiile se aplică automat.",
    button:   "Conectează-te acum",
    helper:   "Crezi că cineva merită rolul sau ai sugestii? Scrie-ne la"
  },
  footer: {
    tagline: "KRIT.RO — Your Friendly Local Game Store"
  }
};

// Imagery used across the page. Hosted on the krit-content bucket under
// landing-assets/pokemon-trainer/. Re-upload via the bucket directly when
// you want to swap any of these.
const CDN = "https://content.krit.ro/landing-assets/pokemon-trainer";
const ASSETS = {
  meowth:           `${CDN}/meowth.png`,
  pidgeotto:        `${CDN}/pidgeotto.png`,
  eevee:            `${CDN}/eevee.png`,
  playPokemonLogo:  `${CDN}/play-pokemon.png`,
  kritLogo:         `${CDN}/krit-logo.png`,
  discordLogo:      "/img/discord-mark.svg"
};

const BENEFITS = [
  {
    icon: "pack",
    title: "Produse Exclusive",
    text: "Ai acces exclusiv la cele mai căutate produse Pokémon TCG, ediții limitate și colecții speciale rezervate doar pentru Pokémon Traineri.",
    pokemon: ASSETS.eevee,
    pokemonAlt: "Eevee"
  },
  {
    icon: "price",
    title: "Prețuri Speciale",
    text: "Cele mai bune prețuri la întreaga gamă Pokémon TCG! Beneficiezi automat de discounturi exclusive, fără coduri sau cupoane.",
    pokemon: ASSETS.meowth,
    pokemonAlt: "Meowth"
  },
  {
    icon: "clock",
    title: "Early Bird Preorders",
    text: "Ai acces prioritar la precomenzile pentru noile expansiuni înainte de a deveni disponibile la liber. Asigură-ți produsele preferate printre primii!",
    pokemon: ASSETS.pidgeotto,
    pokemonAlt: "Pidgeotto"
  }
];

const STEPS = [
  {
    number: "01",
    label: "Optiunea 1",
    title: "Participă la Events",
    text: "Înscrie-te cu contul tău Pokémon Trainer Club la evenimentele KRIT — turnee, trade days, prerelease-uri.",
    criteria: [
      { k: "Ai nevoie de", v: "Cont Pokémon Trainer Club valid + Player ID, cu care te înscrii la evenimente." },
      { k: "Obții rolul", v: "Participând la 3 evenimente în 2 luni." },
      { k: "Păstrezi rolul", v: "Participând la cel puțin 2 evenimente în orice interval de 3 luni." }
    ],
    pokemon: ASSETS.playPokemonLogo,
    pokemonAlt: "Play! Pokémon",
    pokemonClass: "w-[80px] sm:w-[90px] -bottom-3 -right-3"
  },
  {
    number: "02",
    label: "Optiunea 2",
    title: "Contribuie la Comunitate",
    text: "Fii activ și de ajutor pe secțiunea Pokémon de pe serverul de Discord Kritlandia.",
    criteria: [
      { k: "Ai nevoie de", v: "Minim o lună vechime pe server și să fii activ și de ajutor pe secțiunea Pokémon." },
      { k: "Obții rolul", v: "Săptămânal acordăm rolul membrilor care ajută cel mai mult comunitatea." },
      { k: "Păstrezi rolul", v: "Rămânând activ. Inactivitate mai mare de o lună poate duce la pierderea rolului." }
    ],
    pokemon: ASSETS.discordLogo,
    pokemonAlt: "Discord",
    pokemonClass: "w-[90px] sm:w-[100px] bottom-2 -right-3"
  }
];

const RULES = [
  "Rolul Pokémon Trainer este personal și netransmisibil.",
  "Dacă plasezi comenzi pentru alte persoane, îl poți pierde.",
  "Încălcarea regulilor serverului duce cel mai probabil la pierderea rolului."
];

const PokemonTrainerLanding = () => {
  return (
    <>
      <HTMLHead />
      <MetaElement pageId="landing/pokemon-trainer" />

      <style global jsx>{`
        :global(html),
        :global(#__next),
        :global(body) {
          background-color: #eef1f5;
          margin: 0;
          padding: 0;
        }
        :global(html) {
          scroll-behavior: smooth;
        }
        @media (prefers-reduced-motion: reduce) {
          :global(html) { scroll-behavior: auto; }
        }

        @keyframes float-y {
          0%, 100% { transform: translateY(0px) rotate(-6deg); }
          50%      { transform: translateY(-14px) rotate(6deg); }
        }
        @keyframes drift {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          50%      { transform: translate(8px, -10px) rotate(8deg); }
        }
        @keyframes spin-slow { to { transform: rotate(360deg); } }
        @keyframes glow-pulse {
          0%, 100% { box-shadow: 0 0 60px 8px rgba(220, 38, 38, 0.30), 0 0 120px 30px rgba(250, 204, 21, 0.15); }
          50%      { box-shadow: 0 0 90px 14px rgba(14, 165, 233, 0.30), 0 0 140px 40px rgba(250, 204, 21, 0.30); }
        }
        @keyframes shimmer {
          0%   { background-position: -200% center; }
          100% { background-position:  200% center; }
        }
        @keyframes spark {
          0%, 100% { opacity: 0; transform: scale(0.6) rotate(0deg); }
          50%      { opacity: 1; transform: scale(1)   rotate(20deg); }
        }

        .anim-float        { animation: float-y 6s ease-in-out infinite; }
        .anim-drift        { animation: drift 9s ease-in-out infinite; }
        .anim-spin-slow    { animation: spin-slow 24s linear infinite; }
        .anim-glow         { animation: glow-pulse 5s ease-in-out infinite; }
        .anim-spark        { animation: spark 2.4s ease-in-out infinite; }

        .text-shimmer {
          background: linear-gradient(90deg, #b91c1c 0%, #f59e0b 25%, #facc15 50%, #f59e0b 75%, #b91c1c 100%);
          background-size: 200% auto;
          -webkit-background-clip: text;
                  background-clip: text;
          color: transparent;
          animation: shimmer 6s linear infinite;
        }

        .pokeball-dots {
          background-image: radial-gradient(circle at 1px 1px, rgba(15, 23, 42, 0.10) 1px, transparent 0);
          background-size: 22px 22px;
        }
        .grid-lines {
          background-image:
            linear-gradient(rgba(15,23,42,0.05) 1px, transparent 1px),
            linear-gradient(90deg, rgba(15,23,42,0.05) 1px, transparent 1px);
          background-size: 48px 48px;
        }

        .silver-bg {
          background:
            radial-gradient(1200px 600px at 10% -10%, rgba(220, 38, 38, 0.12), transparent 60%),
            radial-gradient(900px 500px at 90% 10%, rgba(14, 165, 233, 0.12), transparent 60%),
            radial-gradient(900px 500px at 50% 110%, rgba(250, 204, 21, 0.18), transparent 60%),
            linear-gradient(180deg, #f8fafc 0%, #e6ebf2 50%, #f1f5f9 100%);
        }

        .holo-shine {
          background:
            linear-gradient(115deg,
              transparent 30%,
              rgba(255, 255, 255, 0.55) 45%,
              rgba(186, 230, 253, 0.55) 50%,
              rgba(254, 240, 138, 0.55) 55%,
              transparent 70%);
          mix-blend-mode: screen;
          pointer-events: none;
        }
      `}</style>

      <main className="relative min-h-screen text-slate-900 font-sans overflow-hidden silver-bg">
        {/* Background FX (whole page) */}
        <div aria-hidden className="pointer-events-none absolute inset-0">
          <div className="absolute inset-0 grid-lines opacity-60" />
          <div className="absolute inset-0 pokeball-dots opacity-70" />
          <Pokeball className="absolute top-[28%] -right-12 w-56 h-56 opacity-25 anim-float" />
          <Pokeball className="absolute top-[68%] -left-14 w-44 h-44 opacity-20 anim-drift" style={{ animationDelay: "1.5s" }} />
          <Sparkles className="absolute top-[12%] right-[12%] w-6 h-6 text-amber-400 anim-spark" />
          <Sparkles className="absolute top-[40%] left-[20%] w-7 h-7 text-rose-400 anim-spark" style={{ animationDelay: "0.8s" }} />
          <Sparkles className="absolute bottom-[30%] right-[8%] w-7 h-7 text-sky-400 anim-spark" style={{ animationDelay: "1.4s" }} />
          <Sparkles className="absolute bottom-[14%] left-[36%] w-6 h-6 text-amber-400 anim-spark" style={{ animationDelay: "0.4s" }} />
        </div>

        {/* Header bar */}
        <div className="relative z-10 px-4 sm:px-6 pt-6 sm:pt-10">
          <div className="max-w-6xl mx-auto">
            <a href={CONTENT.meta.homeUrl} className="inline-flex items-center gap-3 group">
              <img src={ASSETS.kritLogo} alt={CONTENT.meta.brandName} className="h-20 sm:h-28 drop-shadow-sm" />
            </a>
          </div>
        </div>

        {/* Hero */}
        <section className="relative z-10 px-4 sm:px-6 pt-6 pb-14 sm:pt-16 sm:pb-28">
          <div className="max-w-6xl mx-auto grid md:grid-cols-[1fr_auto] gap-10 lg:gap-16 items-center">
            <div className="relative">
              <Sparkles className="absolute -top-6 -left-4 w-10 h-10 text-yellow-400 anim-spark" />
              <Sparkles className="absolute top-2 right-0 w-7 h-7 text-sky-400 anim-spark" style={{ animationDelay: "1s" }} />

              <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black leading-[0.95] tracking-tight mb-5">
                <span className="block text-slate-900">{CONTENT.hero.titleTop}</span>
                <span className="block text-shimmer drop-shadow-sm">{CONTENT.hero.titleBottom}</span>
              </h1>

              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/80 backdrop-blur border border-red-200 text-red-700 text-xs font-bold uppercase tracking-wider mb-6 shadow-sm">
                <span className="relative flex w-2 h-2">
                  <span className="absolute inset-0 rounded-full bg-red-500 animate-ping" />
                  <span className="relative w-2 h-2 rounded-full bg-red-600" />
                </span>
                {CONTENT.hero.badge}
              </div>

              <p className="text-lg sm:text-xl text-slate-600 max-w-xl mb-8 leading-relaxed">
                {CONTENT.hero.subtitle}
              </p>

              <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-4">
                <a
                  href="#cum-il-obtii"
                  className="group relative inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 sm:px-8 py-3.5 sm:py-4 rounded-full bg-gradient-to-r from-red-600 to-red-500 text-white font-bold text-base sm:text-lg shadow-lg shadow-red-600/30 hover:shadow-red-600/50 hover:-translate-y-0.5 transition-all"
                >
                  {CONTENT.hero.ctaPrimary}
                </a>
                <a
                  href={CONTENT.meta.discordConnectUrl}
                  className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 sm:px-8 py-3.5 sm:py-4 rounded-full bg-white text-slate-900 font-bold text-base sm:text-lg border border-slate-200 hover:border-indigo-400 hover:-translate-y-0.5 hover:shadow-lg transition-all"
                >
                  <svg className="w-5 h-5 text-indigo-600" viewBox="0 0 71 55" fill="currentColor"><path d="M60.1 4.9A58.5 58.5 0 0045.7.5c-.6 1.1-1.4 2.6-1.9 3.8a54.1 54.1 0 00-16.2 0c-.5-1.2-1.3-2.7-2-3.8a58.4 58.4 0 00-14.4 4.4A60.6 60.6 0 00.5 46a58.8 58.8 0 0017.7 8.9 44 44 0 003.8-6.1 38 38 0 01-6-2.9c.5-.4 1-.8 1.4-1.2a42 42 0 0036.2 0 19.6 19.6 0 001.5 1.2c-1.9 1.1-4 2-6 3a44 44 0 003.7 6 58.5 58.5 0 0017.7-9 60 60 0 00-10.4-41zM23.7 37.3c-3.5 0-6.4-3.2-6.4-7.1 0-4 2.8-7.2 6.4-7.2s6.5 3.3 6.4 7.2c0 3.9-2.8 7-6.4 7zm23.6 0c-3.5 0-6.4-3.2-6.4-7.1 0-4 2.8-7.2 6.4-7.2s6.5 3.3 6.4 7.2c0 3.9-2.8 7-6.4 7z" /></svg>
                  {CONTENT.hero.ctaSecondary}
                </a>
              </div>
            </div>

            {/* Hero pokeball + Pikachu */}
            <div className="hidden md:flex items-center justify-center">
              <div className="relative">
                <div className="absolute inset-0 rounded-full anim-glow" />
                <div className="absolute -inset-8 rounded-full border-2 border-dashed border-yellow-400/50 anim-spin-slow" />
                <Sparkles className="absolute -top-4 -right-2 w-10 h-10 text-yellow-400 anim-spark" />
                <Sparkles className="absolute -bottom-2 -left-4 w-8 h-8 text-sky-400 anim-spark" style={{ animationDelay: "0.6s" }} />
                <div className="anim-float">
                  <Pokeball className="relative w-72 h-72 lg:w-80 lg:h-80 drop-shadow-2xl" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="relative z-10 py-14 sm:py-28 px-4 sm:px-6 bg-white/55 border-y border-slate-200/70">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-10 sm:mb-14">
              <p className="text-red-600 font-bold text-sm uppercase tracking-[0.2em] mb-3">{CONTENT.benefits.kicker}</p>
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-slate-900">{CONTENT.benefits.title}</h2>
              <p className="text-slate-600 mt-4 max-w-2xl mx-auto">
                {CONTENT.benefits.subtitle}
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
              {BENEFITS.map((b) => (
                <article
                  key={b.title}
                  className="group relative transition-all duration-300 hover:-translate-y-1.5"
                >
                  <div className="relative rounded-3xl bg-white border border-slate-200 shadow-[0_10px_30px_-10px_rgba(15,23,42,0.18)] group-hover:shadow-[0_30px_60px_-20px_rgba(15,23,42,0.28)] transition-shadow duration-300 overflow-hidden">
                    <div className="absolute inset-0 holo-shine opacity-0 group-hover:opacity-50 transition-opacity duration-500" />
                    <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-red-500 via-amber-400 to-yellow-300" />

                    <div className="relative p-5 sm:p-8 pr-24">
                      <div className="relative inline-flex w-14 h-14 mb-5 items-center justify-center rounded-2xl bg-gradient-to-br from-red-50 to-amber-50 border border-red-100 text-red-600 shadow-sm">
                        <PerkIcon name={b.icon} className="w-7 h-7" />
                      </div>

                      <h3 className="text-xl sm:text-2xl font-extrabold mb-3 text-slate-900">{b.title}</h3>
                      <p className="text-slate-600 text-sm sm:text-base leading-relaxed">{b.text}</p>
                    </div>
                  </div>

                  <img
                    src={b.pokemon}
                    alt={b.pokemonAlt}
                    loading="lazy"
                    className={`absolute select-none pointer-events-none transition-transform duration-500 group-hover:-translate-y-1 group-hover:rotate-3 ${b.pokemonClass || "-top-10 -right-4 w-32 sm:w-36"} ${b.pokemonBlend ? "" : "drop-shadow-[0_15px_25px_rgba(15,23,42,0.28)]"}`}
                    style={b.pokemonBlend ? { mixBlendMode: "multiply" } : undefined}
                  />
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Steps */}
        <section id="cum-il-obtii" className="relative z-10 py-14 sm:py-28 px-4 sm:px-6 bg-rose-50/55 border-b border-rose-100/70">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-10 sm:mb-14">
              <p className="text-sky-600 font-bold text-sm uppercase tracking-[0.2em] mb-3">{CONTENT.steps.kicker}</p>
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-slate-900">{CONTENT.steps.title}</h2>
              <p className="text-slate-600 mt-4 max-w-2xl mx-auto">
                {CONTENT.steps.subtitle}
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
              {STEPS.map((s) => (
                <div
                  key={s.number}
                  className="group relative flex transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="relative w-full flex flex-col p-6 sm:p-10 rounded-3xl bg-white/85 backdrop-blur border border-slate-200 shadow-[0_10px_30px_-10px_rgba(15,23,42,0.15)] group-hover:shadow-[0_30px_60px_-20px_rgba(220,38,38,0.25)] transition-shadow duration-300 overflow-hidden">
                    <div className="absolute -top-12 -right-6 text-[180px] font-black text-red-500/10 leading-none select-none">
                      {s.number}
                    </div>

                    <div className="relative pr-24 sm:pr-28">
                      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-100 text-red-700 text-xs font-bold uppercase tracking-wider mb-5">
                        {s.label}
                      </div>
                      <h3 className="text-2xl sm:text-3xl font-extrabold mb-4 text-slate-900">{s.title}</h3>
                      <p className="text-slate-600 leading-relaxed">{s.text}</p>

                      {s.criteria && (
                        <dl className="mt-6 space-y-4 border-t border-slate-100 pt-5">
                          {s.criteria.map((c) => (
                            <div key={c.k}>
                              <dt className="text-xs font-black uppercase tracking-wider text-red-600 mb-1">{c.k}</dt>
                              <dd className="text-sm text-slate-600 leading-relaxed">{c.v}</dd>
                            </div>
                          ))}
                        </dl>
                      )}
                    </div>
                  </div>

                  <img
                    src={s.pokemon}
                    alt={s.pokemonAlt}
                    loading="lazy"
                    className={`absolute select-none pointer-events-none drop-shadow-[0_20px_30px_rgba(15,23,42,0.28)] transition-transform duration-500 group-hover:-translate-y-1 group-hover:scale-105 ${s.pokemonClass || "-bottom-10 -right-8 w-44 sm:w-48"}`}
                  />
                </div>
              ))}
            </div>

            {/* time-boxed grandfather notice */}
            <div className="mt-8 sm:mt-10 relative rounded-3xl border border-amber-300 bg-gradient-to-r from-amber-50 via-yellow-50 to-amber-50 p-5 sm:p-7 overflow-hidden">
              <Sparkles className="absolute -top-2 -left-2 w-10 h-10 text-amber-400 anim-spark" />
              <Sparkles className="absolute -bottom-2 -right-2 w-10 h-10 text-amber-400 anim-spark" style={{ animationDelay: "0.8s" }} />
              <div className="relative flex flex-col sm:flex-row sm:items-center gap-4">
                <div className="flex flex-col sm:flex-row sm:items-start gap-3 flex-1">
                  <div className="text-xs font-black uppercase tracking-widest text-amber-800 bg-amber-200 px-2 py-1 rounded-md self-start">
                    {CONTENT.steps.notice.badge}
                  </div>
                  <p className="text-slate-800 text-sm sm:text-base leading-relaxed">
                    {CONTENT.steps.notice.text}
                  </p>
                </div>
                <a
                  href={CONTENT.meta.eventsUrl}
                  className="inline-flex items-center justify-center gap-2 shrink-0 self-stretch sm:self-auto px-5 py-3 rounded-full bg-red-600 text-white font-bold text-sm sm:text-base shadow-md shadow-red-600/25 hover:bg-red-700 hover:shadow-red-600/45 hover:-translate-y-0.5 transition-all"
                >
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
                  {CONTENT.steps.notice.cta}
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Rules — how you keep the role */}
        <section className="relative z-10 py-14 sm:py-28 px-4 sm:px-6 bg-white/55 border-b border-slate-200/70">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8 sm:mb-12">
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-slate-900">{CONTENT.rules.title}</h2>
              <p className="text-slate-600 mt-4 max-w-xl mx-auto">{CONTENT.rules.subtitle}</p>
            </div>

            <ul className="rounded-3xl bg-white/85 backdrop-blur border border-slate-200 shadow-[0_10px_30px_-10px_rgba(15,23,42,0.15)] divide-y divide-slate-100 overflow-hidden">
              {RULES.map((r) => (
                <li key={r} className="flex items-start gap-3 px-5 sm:px-8 py-4">
                  <span className="mt-2 flex-shrink-0 w-2 h-2 rounded-full bg-red-500" />
                  <span className="text-slate-700 text-sm sm:text-base leading-relaxed">{r}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* CTA */}
        <section className="relative z-10 py-14 sm:py-28 px-4 sm:px-6 bg-indigo-50/50">
          <div className="max-w-4xl mx-auto">
            <div className="relative rounded-3xl overflow-hidden border border-indigo-200 shadow-[0_30px_70px_-20px_rgba(79,70,229,0.35)] bg-gradient-to-br from-white via-indigo-50 to-violet-50 p-6 sm:p-14 text-center">
              <Pokeball className="absolute -bottom-16 -right-10 w-56 h-56 opacity-20 anim-float" />
              <Sparkles className="absolute top-6 right-10 w-8 h-8 text-yellow-400 anim-spark" />
              <Sparkles className="absolute -top-2 -left-2 w-10 h-10 text-amber-400 anim-spark" style={{ animationDelay: "0.8s" }} />
              <Sparkles className="absolute bottom-10 left-10 w-9 h-9 text-rose-400 anim-spark" style={{ animationDelay: "1.4s" }} />

              <div className="relative">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-indigo-600/10 border border-indigo-300 text-indigo-700 text-xs font-bold uppercase tracking-wider mb-6">
                  <svg className="w-4 h-4" viewBox="0 0 71 55" fill="currentColor"><path d="M60.1 4.9A58.5 58.5 0 0045.7.5c-.6 1.1-1.4 2.6-1.9 3.8a54.1 54.1 0 00-16.2 0c-.5-1.2-1.3-2.7-2-3.8a58.4 58.4 0 00-14.4 4.4A60.6 60.6 0 00.5 46a58.8 58.8 0 0017.7 8.9 44 44 0 003.8-6.1 38 38 0 01-6-2.9c.5-.4 1-.8 1.4-1.2a42 42 0 0036.2 0 19.6 19.6 0 001.5 1.2c-1.9 1.1-4 2-6 3a44 44 0 003.7 6 58.5 58.5 0 0017.7-9 60 60 0 00-10.4-41zM23.7 37.3c-3.5 0-6.4-3.2-6.4-7.1 0-4 2.8-7.2 6.4-7.2s6.5 3.3 6.4 7.2c0 3.9-2.8 7-6.4 7zm23.6 0c-3.5 0-6.4-3.2-6.4-7.1 0-4 2.8-7.2 6.4-7.2s6.5 3.3 6.4 7.2c0 3.9-2.8 7-6.4 7z" /></svg>
                  {CONTENT.cta.badge}
                </div>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-black mb-5 text-slate-900">
                  {CONTENT.cta.title}
                </h2>
                <p className="text-slate-600 text-base sm:text-lg max-w-2xl mx-auto mb-7 sm:mb-10">
                  {CONTENT.cta.subtitle}
                </p>
                <a
                  href={CONTENT.meta.discordConnectUrl}
                  className="inline-flex items-center justify-center gap-3 px-7 sm:px-10 py-4 sm:py-5 rounded-full bg-gradient-to-r from-indigo-600 to-violet-600 text-white font-bold text-base sm:text-lg shadow-xl shadow-indigo-600/30 hover:shadow-indigo-600/50 hover:-translate-y-0.5 transition-all"
                >
                  <svg className="w-6 h-6" viewBox="0 0 71 55" fill="currentColor"><path d="M60.1 4.9A58.5 58.5 0 0045.7.5c-.6 1.1-1.4 2.6-1.9 3.8a54.1 54.1 0 00-16.2 0c-.5-1.2-1.3-2.7-2-3.8a58.4 58.4 0 00-14.4 4.4A60.6 60.6 0 00.5 46a58.8 58.8 0 0017.7 8.9 44 44 0 003.8-6.1 38 38 0 01-6-2.9c.5-.4 1-.8 1.4-1.2a42 42 0 0036.2 0 19.6 19.6 0 001.5 1.2c-1.9 1.1-4 2-6 3a44 44 0 003.7 6 58.5 58.5 0 0017.7-9 60 60 0 00-10.4-41zM23.7 37.3c-3.5 0-6.4-3.2-6.4-7.1 0-4 2.8-7.2 6.4-7.2s6.5 3.3 6.4 7.2c0 3.9-2.8 7-6.4 7zm23.6 0c-3.5 0-6.4-3.2-6.4-7.1 0-4 2.8-7.2 6.4-7.2s6.5 3.3 6.4 7.2c0 3.9-2.8 7-6.4 7z" /></svg>
                  {CONTENT.cta.button}
                </a>
                <p className="text-slate-500 text-sm mt-6">
                  {CONTENT.cta.helper}{" "}
                  <a href={`mailto:${CONTENT.meta.contactEmail}`} className="text-red-600 hover:text-red-700 underline">{CONTENT.meta.contactEmail}</a>
                  {" "}ori pe Discord.
                </p>
              </div>
            </div>
          </div>
        </section>


      </main>
    </>
  );
};

const PerkIcon = ({ name, className = "" }) => {
  if (name === "pack") {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="3" width="14" height="18" rx="2" fill="rgba(220,38,38,0.08)" />
        <path d="M5 8h14" />
        <path d="M12 3v18" />
        <path d="M9 12l3 2 3-2" />
      </svg>
    );
  }
  if (name === "price") {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 12 12 20l-8-8V4h8z" fill="rgba(220,38,38,0.08)" />
        <circle cx="8" cy="8" r="1.4" fill="currentColor" />
        <path d="M14 11l-3 3" />
        <path d="M13 14l1 1" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="13" r="8" fill="rgba(220,38,38,0.08)" />
      <path d="M12 9v4l3 2" />
      <path d="M9 2h6" />
      <path d="M12 2v3" />
    </svg>
  );
};

PokemonTrainerLanding.getInitialProps = async () => ({ landingPage: true });

export default PokemonTrainerLanding;
